import {
	Component,
	Input,
	OnInit,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { PartnerInsightService } from 'app/services/partner/partner-insights.service';
import { BaseInsightRequest } from 'app/models/partner/base-insight-request.model';
import { ProductInsight } from 'app/models/partner/insight-models';
import { MessageService } from 'primeng/api';
import { MatTableDataSource } from '@angular/material/table';
import { Utils } from 'app/utils/utils';
import { GetMostPopularProductsResponse } from 'app/partner/response-insight.model';
import { Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
	selector: 'most-popular-products',
	templateUrl: './most-popular-products.component.html',
	styleUrls: ['./most-popular-products.component.scss'],
})
export class MostPopularProductsComponent implements OnInit, OnChanges {
	@Input() locationId: number = 0;
	@Input() fromDate: Date = new Date();
	@Input() toDate: Date = new Date();

	public displayedColumns: string[] = [
		'ProductName',
		'Quantity',
		'SalesRevenue',
	];
	public dataSource = new MatTableDataSource<ProductInsight>([]);
	loading = false;
	isEmpty = false;

	constructor(
		private partnerInsightService: PartnerInsightService,
		private messageService: MessageService,
		private liveAnnouncer: LiveAnnouncer
	) {}

	ngOnInit() {
		this.loadPopularProducts();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['locationId'] || changes['fromDate'] || changes['toDate']) {
			this.loadPopularProducts();
		}
	}

	onPopularProductsSortChange(sortState: Sort) {
		if (sortState.direction) {
			this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
		} else {
			this.liveAnnouncer.announce('Sorting cleared');
		}
	}

	public loadPopularProducts() {
		this.loading = true;
		this.isEmpty = false;

		const request: BaseInsightRequest = {
			TimeZoneOffset: Utils.getTimezoneOffset(),
			LocationId: this.locationId,
			FromDate: this.fromDate,
			ToDate: this.toDate,
			Skip: 0,
			Take: 5,
		};

		this.partnerInsightService
			.getMostPopularProducts(request, this.messageService)
			.then((response: GetMostPopularProductsResponse) => {
				if (response.Success && response.Items?.length) {
					const mostPopularProducts = response.Items.map((item) => ({
						ProductId: item.ProductId,
						ProductName: item.ProductName,
						ImageUrl: item.ImageUrl,
						Quantity: item.Quantity,
						SalesRevenue: item.SalesRevenue,
					}));

					this.dataSource.data = mostPopularProducts;
					this.isEmpty = false;
				} else {
					this.dataSource.data = [];
					this.isEmpty = true;
				}
			})
			.catch(() => {
				this.messageService.add({
					severity: 'error',
					summary: 'Error',
					detail: 'Failed to load most popular products',
				});
				this.dataSource.data = [];
				this.isEmpty = true;
			})
			.finally(() => {
				this.loading = false;
			});
	}
}
